/**
 * Bootstrap JS
 */

import 'bootstrap-sass/assets/javascripts/bootstrap/affix.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/alert.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/button.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/carousel.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/dropdown.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/modal.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/tooltip.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/popover.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/tab.js';
// import 'bootstrap-sass/assets/javascripts/bootstrap/scrollspy.js';
import 'bootstrap-sass/assets/javascripts/bootstrap/transition.js';



// WEBPACK FOOTER //
// ./assets/js/lib/bootstrap.js